export const MOBILE = 320;
export const TABLET = 480;
export const DESKTOP = 1024;
